import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { useScript } from '@lean-body/src/util';
import { SessionStorage } from '@lean-body/src/infra';
const BUTTON_COLOR = 'Gold';
const PRODUCT_TYPE = 'PayOnly';
const PLACEMENT = 'Checkout';
const LEDGER_CURRENCY = 'JPY';
const CHECKOUT_LANGUAGE = 'ja_JP';
// propsのplanが変更された時だけ実行したいので、React.memoを使用
export const AmazonPayButton = React.memo(({ classObject, plan, campaign, config, onClick, disabled }) => {
    const sessionStorage = new SessionStorage();
    const elementId = `AmazonPayButton-PlanId-${plan.id}`;
    const payloadJSON = typeof plan.payload === 'string' ? plan.payload : JSON.stringify(plan.payload);
    const buttonPayload = {
        createCheckoutSessionConfig: {
            payloadJSON,
            signature: plan.signature,
            publicKeyId: config.amazonPayPublicKeyId,
        },
    };
    const [amazonPayButton, setAmazonPayButton] = React.useState(null);
    React.useEffect(() => {
        if (amazonPayButton) {
            amazonPayButton.onClick(() => amazonPayButton.initCheckout(buttonPayload));
        }
    }, [plan]);
    useScript('https://static-fe.payments-amazon.com/checkout.js', () => {
        const button = window.amazon.Pay.renderButton(`#${elementId}`, {
            merchantId: config.amazonPayMerchantId,
            ledgerCurrency: LEDGER_CURRENCY, // JPY
            sandbox: !config.isProduction,
            checkoutLanguage: CHECKOUT_LANGUAGE,
            productType: PRODUCT_TYPE, // PayOnly: デジタルサービス(物理なし)のタイプ
            placement: PLACEMENT, // AmazonPayボタンの配置場所(厳密な意図は不明)
            buttonColor: BUTTON_COLOR,
        });
        setAmazonPayButton(button);
        button.onClick(() => button.initCheckout(buttonPayload));
    });
    const onClickHandler = () => {
        sessionStorage.setAmazonPayParams(plan.id, campaign === null || campaign === void 0 ? void 0 : campaign.campaignCode, new URLSearchParams(location.search));
        onClick && onClick();
    };
    const onClickDisableContainer = (e) => {
        e.stopPropagation();
        onClick && onClick();
    };
    return (React.createElement("div", { className: css(styles.container, classObject), onClick: onClickHandler },
        React.createElement("div", { id: elementId, className: css(styles.button) }),
        disabled && React.createElement("div", { className: css(styles.disableContainer), onClick: onClickDisableContainer })));
});
const styles = StyleSheet.create({
    container: {
        position: 'relative',
    },
    button: {
        height: 65,
        width: '100%',
    },
    disableContainer: {
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
    },
});
